var map = {
	"./1.jpg": 2150,
	"./10.jpg": 2151,
	"./2.jpg": 2152,
	"./3.jpg": 2153,
	"./4.jpg": 2154,
	"./5.jpg": 2155,
	"./6.jpg": 2156,
	"./7.jpg": 2157,
	"./8.jpg": 2158,
	"./9.jpg": 2159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2149;